var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmaranth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#FBC689;}\n\t.st2{fill:#FDD9B7;}\n\t.st3{fill:#F7B178;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.06,
    cy: 110.25,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 100.36,
    cy: 106.89,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.06,115.63c-3.99,0-7.29-2.9-7.93-6.71c-0.07,0.44-0.12,0.88-0.12,1.34c0,4.44,3.6,8.05,8.05,8.05 s8.05-3.6,8.05-8.05c0-0.46-0.05-0.9-0.12-1.34C107.35,112.72,104.05,115.63,100.06,115.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 108.65,
    cy: 91.09,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9586 -0.2848 0.2848 0.9586 -20.5269 34.3815)",
    className: "st2",
    cx: 107.98,
    cy: 87.78,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.18,96.25c-3.82,1.14-7.82-0.71-9.51-4.18c0.05,0.44,0.14,0.88,0.27,1.32c1.27,4.26,5.75,6.69,10.01,5.42 c4.26-1.27,6.69-5.75,5.42-10.01c-0.13-0.44-0.3-0.85-0.5-1.25C116.34,91.39,114,95.11,110.18,96.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 89.91,
    cy: 90.37,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5805 -0.8143 0.8143 0.5805 -35.1569 108.1156)",
    className: "st2",
    cx: 87.34,
    cy: 88.18,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.28,93.49c-2.32,3.25-6.6,4.25-10.07,2.56c0.31,0.31,0.65,0.61,1.02,0.87c3.62,2.58,8.65,1.74,11.23-1.88 c2.58-3.62,1.74-8.65-1.88-11.23c-0.37-0.26-0.76-0.48-1.16-0.68C96.15,85.87,96.6,90.24,94.28,93.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 128.65,
    cy: 84.73,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2573 -0.9663 0.9663 0.2573 12.4268 183.3109)",
    className: "st2",
    cx: 125.47,
    cy: 83.57,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.84,86.11c-1.03,3.85-4.68,6.3-8.53,5.93c0.4,0.18,0.82,0.34,1.26,0.46c4.3,1.14,8.7-1.41,9.85-5.71 c1.14-4.3-1.41-8.7-5.71-9.85c-0.44-0.12-0.88-0.19-1.32-0.23C132.91,78.32,134.87,82.26,133.84,86.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 113.55,
    cy: 65.71,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1691 -0.9856 0.9856 0.1691 33.5172 164.6456)",
    className: "st2",
    cx: 114.41,
    cy: 62.44,
    rx: 2.16,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.64,71.01c-3.93-0.67-6.69-4.1-6.68-7.96c-0.15,0.42-0.27,0.85-0.34,1.3c-0.75,4.38,2.19,8.54,6.57,9.29 c4.38,0.75,8.54-2.19,9.29-6.57c0.08-0.45,0.11-0.9,0.11-1.34C120.31,69.38,116.57,71.68,112.64,71.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 93.09,
    cy: 71.27,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4377 -0.8991 0.8991 0.4377 -11.799 120.1938)",
    className: "st2",
    cx: 90.2,
    cy: 69.53,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.92,73.63c-1.75,3.59-5.8,5.28-9.51,4.19c0.36,0.26,0.74,0.49,1.15,0.69c4,1.95,8.81,0.28,10.76-3.71 c1.95-4,0.28-8.81-3.71-10.76c-0.41-0.2-0.83-0.35-1.25-0.48C98.5,65.8,99.67,70.04,97.92,73.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 72.84,
    cy: 79.94,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4377 -0.8991 0.8991 0.4377 -30.9773 106.8554)",
    className: "st2",
    cx: 69.94,
    cy: 78.19,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.67,82.29c-1.75,3.59-5.8,5.28-9.51,4.19c0.36,0.26,0.74,0.49,1.15,0.69c4,1.95,8.81,0.28,10.76-3.71 c1.95-4,0.28-8.81-3.71-10.76c-0.41-0.2-0.83-0.35-1.25-0.48C78.25,74.46,79.42,78.7,77.67,82.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.27,
    cy: 100.1,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 73.57,
    cy: 96.74,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.27,105.48c-3.99,0-7.29-2.9-7.93-6.71c-0.07,0.44-0.12,0.88-0.12,1.34c0,4.44,3.6,8.05,8.05,8.05 s8.05-3.6,8.05-8.05c0-0.46-0.05-0.9-0.12-1.34C80.56,102.57,77.26,105.48,73.27,105.48z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.9,
    cy: 145.57,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7312 -0.6821 0.6821 0.7312 -68.433 113.3063)",
    className: "st2",
    cx: 109.57,
    cy: 143.49,
    rx: 2.16,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.97,149.24c-2.72-2.92-2.85-7.31-0.5-10.38c-0.37,0.24-0.73,0.51-1.06,0.82 c-3.25,3.03-3.43,8.12-0.4,11.38c3.03,3.25,8.12,3.43,11.38,0.4c0.33-0.31,0.63-0.65,0.9-1 C110.07,152.59,105.69,152.15,102.97,149.24z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 126.77,
    cy: 138.78,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5067 -0.8621 0.8621 0.5067 -53.7719 178.0882)",
    className: "st2",
    cx: 128.74,
    cy: 136.03,
    rx: 2.16,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.05,143.41c-3.44-2.02-4.81-6.2-3.43-9.8c-0.28,0.34-0.55,0.7-0.78,1.09c-2.25,3.83-0.97,8.76,2.86,11.02 c3.83,2.25,8.76,0.97,11.02-2.86c0.23-0.39,0.42-0.8,0.57-1.21C131.81,144.61,127.49,145.44,124.05,143.41z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 114.52,
    cy: 124.59,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9914 -0.131 0.131 0.9914 -14.8938 16.0285)",
    className: "st2",
    cx: 114.38,
    cy: 121.21,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.22,129.92c-3.95,0.52-7.61-1.92-8.74-5.62c-0.02,0.44,0,0.89,0.06,1.34c0.58,4.41,4.63,7.51,9.03,6.92 c4.41-0.58,7.51-4.63,6.92-9.03c-0.06-0.45-0.16-0.89-0.29-1.31C122.07,126.08,119.18,129.39,115.22,129.92z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 148.68,
    cy: 125.05,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8361 -0.5486 0.5486 0.8361 -42.8687 103.4408)",
    className: "st2",
    cx: 151.66,
    cy: 123.45,
    rx: 2.16,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.19,128c-2.19-3.33-1.57-7.69,1.26-10.31c-0.4,0.18-0.8,0.38-1.18,0.63c-3.72,2.44-4.75,7.43-2.31,11.14 c2.44,3.72,7.43,4.75,11.14,2.31c0.38-0.25,0.73-0.53,1.05-0.83C150.61,132.5,146.37,131.33,144.19,128z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 130.66,
    cy: 113.89,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.956 -0.2932 0.2932 0.956 -26.7143 42.9708)",
    className: "st2",
    cx: 129.96,
    cy: 110.58,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.23,119.02c-3.81,1.17-7.82-0.64-9.55-4.09c0.06,0.44,0.14,0.88,0.28,1.31c1.3,4.25,5.81,6.64,10.05,5.33 c4.25-1.3,6.64-5.81,5.33-10.05c-0.13-0.44-0.31-0.85-0.51-1.24C138.35,114.11,136.05,117.85,132.23,119.02z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 93.52,
    cy: 129.66,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.956 -0.2932 0.2932 0.956 -32.9727 32.7732)",
    className: "st2",
    cx: 92.82,
    cy: 126.36,
    rx: 4.5,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.09,134.8c-3.81,1.17-7.82-0.64-9.55-4.09c0.06,0.44,0.14,0.88,0.28,1.31c1.3,4.25,5.81,6.64,10.05,5.33 s6.64-5.81,5.33-10.05c-0.13-0.44-0.31-0.85-0.51-1.24C101.21,129.88,98.91,133.63,95.09,134.8z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 69.16,
    cy: 128.56,
    r: 8.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7312 -0.6821 0.6821 0.7312 -66.9781 82.9859)",
    className: "st2",
    cx: 71.82,
    cy: 126.49,
    rx: 2.16,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.22,132.23c-2.72-2.92-2.85-7.31-0.5-10.38c-0.37,0.24-0.73,0.51-1.06,0.82c-3.25,3.03-3.43,8.12-0.4,11.38 c3.03,3.25,8.12,3.43,11.38,0.4c0.33-0.31,0.63-0.65,0.9-1C72.32,135.58,67.95,135.15,65.22,132.23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmaranth);
export default __webpack_public_path__ + "static/media/Amaranth.d7121526706645bb78c77d83558ffaa2.svg";
export { ForwardRef as ReactComponent };